import { Box, IconButton, Stack, Typography, Button } from '@mui/material';
import AddCertification from 'components/basic-profile/AddCertification';
import { DeleteSvg, WhiteEditSvgIcon } from 'components/icon/icon';
import { allCapitalize } from 'utils/Utils';
const backIcon = `${process.env.REACT_APP_HOMEPAGE}assets/back-arrow-white.png`;

/**
 * AddCertificationDrawer is a component that renders a drawer for adding certifications.
 * It contains a form with fields for certificate received, education institute name, and skills.
 * It also contains a button to save the certification and a button to delete the certification if it already exists.
 * The component also renders a back button to navigate back to the certification list.
 *
 * @param {Object} props
 * @param {function} props.onCertificateDataChange - a function that is called when the certification form is submitted.
 * @param {Array} props.certificateInstituteData - an array of objects containing the names of the institutes.
 * @param {Array} props.certificateTitleData - an array of objects containing the names of the certificates.
 * @param {function} props.checkingOverlapping - a function that is called when the user is adding a new certification and it needs to check if the certification already exists.
 * @param {function} props.onCancel - a function that is called when the user clicks the cancel button.
 * @param {Object} props.certificateData - an object containing the data of the certification to be edited.
 * @param {string} props.id - the id of the certification to be edited.
 * @param {Object} props.selected - an object containing the data of the certification selected by the user.
 * @param {function} props.handleDeleteCertificate - a function that is called when the user clicks the delete button.
 * @param {function} props.handleArrowClick - a function that is called when the user clicks the back button.
 * @param {boolean} props.showCert - a boolean indicating if the certification list is visible.
 * @param {function} props.handleShowCert - a function that is called when the user clicks the show/hide certification button.
 * @param {function} props.handleDeleteEdu - a function that is called when the user clicks the delete education button.
 * @param {boolean} props.isReadOnly - a boolean indicating if the certification is read only.
 * @param {function} props.setReadOnly - a function that is called when the user clicks the edit button.
 */
const AddCertificationDrawer = ({
    onCertificateDataChange,
    certificateInstituteData,
    certificateTitleData,
    checkingOverlapping,
    onCancel,
    certificateData,
    id,
    selected,
    handleDeleteCertificate,
    handleArrowClick,
    showCert, handleShowCert, handleDeleteEdu, isReadOnly, setReadOnly, deleteIncompleteSection
}) => {

    return (
        <Box className="sidebar-wrapper">
            <Box className="sidebar-header">
                <Stack direction="row" justifyContent={'flex-start'} alignItems={'flex-start'} spacing={2}>
                    <IconButton aria-label="delete" onClick={() => handleArrowClick()}>
                        <img src={backIcon} alt="Back" width="20px" height="20px" loading="lazy" />
                    </IconButton>
                    <Stack direction="row" justifyContent={'space-between'} alignItems={'flex-start'} sx={{ minWidth: '100%' }}>
                        <Stack spacing={0.5}>
                            <Typography className="title">Add Certification</Typography>
                            <Typography className="sub-text" sx={{ width: '85%' }}>
                                {selected && selected?.certificate_received && selected?.education_institute_name ? `${selected?.certificate_received} at ${allCapitalize(selected?.education_institute_name)}`
                                    : 'Select Certificate Received & Institute'}
                            </Typography>
                        </Stack>
                        {!isReadOnly ?
                            <IconButton className="delete-sec-btn" aria-label="delete" onClick={id ? (e) => { handleDeleteCertificate(selected._id, selected?.certificate_received, e) } : deleteIncompleteSection}>
                                <DeleteSvg />
                            </IconButton> :
                            <IconButton aria-label="delete" className="edit-icon" disableRipple onClick={() => setReadOnly(false)} sx={{ position: 'absolute', right: '20px', top: '6px' }}>
                                <WhiteEditSvgIcon />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            </Box>
            <Box className="sidebar-content" sx={{ backgroundColor: showCert && '#FAFAFA!important' }} mb={8}>
                <AddCertification
                    onCertificateDataChange={onCertificateDataChange}
                    certificateInstituteData={certificateInstituteData}
                    certificateTitleData={certificateTitleData}
                    checkingOverlapping={checkingOverlapping}
                    onCancel={onCancel}
                    certificateData={certificateData}
                    id={id}
                    handleArrowClick={handleArrowClick}
                    showCert={showCert}
                    handleShowCert={handleShowCert}
                    handleDeleteEdu={handleDeleteEdu}
                    isReadOnly={isReadOnly}
                    setReadOnly={setReadOnly}
                />
            </Box>
        </Box>
    )
}

export default AddCertificationDrawer
